var $ = jQuery;
var pricingCompare = function () {
  var tableHeader = $('.table-headings').not('.addon-pricing-header, .localized-pricing-plans-comparison-table');
  var tableHeaderPosition = (tableHeader.offset() || { 'top': NaN }).top;
  if (tableHeader.length > 0) {
    $(window).scroll(function () {
      if ($(window).width() > 720) {
        var scrollPosition = $(window).scrollTop();
        if (scrollPosition > tableHeaderPosition) {
          tableHeader.addClass('table-stuck');
        } else {
          if (tableHeader.hasClass('table-stuck')) {
            tableHeader.removeClass('table-stuck');
          }
        }
      }
    });
  }
};

var detailCompareTable = function () {
  $(document).ready(function () {
    var tableHeader = $('.detail-comparison-table .header-section');
    if (tableHeader.length > 0) {
      var tableDataSection = $('.comparison-section');
      var tableHeaderPosition = (tableHeader.offset() || { 'top': NaN }).top;
      var tableBottomPosition = tableDataSection.offset().top + tableDataSection.height() - tableHeader.height();
      var hasStickyHeader = $('.detail-comparison-table').hasClass('has-sticky-header');
      if ($('nav.has-secondary').length > 0) {
        hasStickyHeader = false;
      }
      if (hasStickyHeader) {
        $(window).scroll(function () {
          if ($(window).width() > 720) {
            var scrollPosition = $(window).scrollTop();
            if ((scrollPosition > tableHeaderPosition) && (scrollPosition < tableBottomPosition)) {
              tableHeader.addClass('table-header-stuck');
            } else {
              if (tableHeader.hasClass('table-header-stuck')) {
                tableHeader.removeClass('table-header-stuck');
              }
            }
          }
        });
      }
    }
  });
};

const tableSticky = {
  pricingCompare,
  detailCompareTable
};

export { tableSticky };
